import LoginControllerBase from "../LoginControllerBase";

class LoginCarsNowController extends LoginControllerBase {
  constructor($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums) {
    "ngInject";

    super($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums);

    this.initialize();
  }
}

export default LoginCarsNowController;



// WEBPACK FOOTER //
// ./client/app/components/login/loginCarsNow/loginCarsNow.controller.js